import React, { useEffect, useCallback } from "react";
import { Modal, ModalBody } from "@nef/core";

import RegisterSuccess from "../register-success";
import useAuth from "../../hooks/useAuth";
import { getMyOrganizations } from "../../api/api";
import {
  MODAL_TYPES,
  useGlobalModalContext
} from "../../context/modal-context";

const RegistrationSuccessModal = ({ skipOrgCheck }: any) => {
  const { authenticatedUser, logout } = useAuth();
  const { showModal } = useGlobalModalContext();

  useEffect(() => {
    let isMounted = true;
    if (!skipOrgCheck) {
      getMyOrganizations().then((response: any) => {
        if (!isMounted) return;

        const orgs = response.data.organizations || [];
        if (orgs.length === 0) logout(); // self signup users will be logged out here.

        // After loading, if there are pending ToU or Welcome actions, open them first
        const orgsPendingAcceptance = orgs.filter(
          (org: any) => org.needToAcceptTerms
        );
        const orgsPendingWelcome = orgs.filter(
          (org: any) => !org.welcomeAcceptedByMe && !org.hasTerms
        );

        if (orgsPendingAcceptance.length > 0) {
          showModal(MODAL_TYPES.ACCEPT_TOU_MODAL, {
            title: "Accept terms of use",
            name: authenticatedUser?.first_name as string,
            orgName: orgsPendingAcceptance[0]?.name as string,
            orgId: orgsPendingAcceptance[0]?.id as number,
            onDone: handleReturnToSuccess
          });
        } else if (orgsPendingWelcome.length > 0) {
          showModal(MODAL_TYPES.ACCEPT_WELCOME, {
            title: "Accept welcome",
            name: authenticatedUser?.first_name as string,
            orgName: orgsPendingWelcome[0]?.name as string,
            orgId: orgsPendingWelcome[0]?.id as number,
            onDone: handleReturnToSuccess
          });
        }
      });
    }

    return () => {
      isMounted = false;
    };
  }, [authenticatedUser?.email, authenticatedUser?.first_name, skipOrgCheck]);

  const handleReturnToSuccess = useCallback(async () => {
    try {
      await logout();
    } catch (e) {
      // noop
    }
    // Re-open the registration success modal but tell it to skip the org
    // check so we don't immediately open any child modals again.
    showModal(MODAL_TYPES.REGISTRATION_SUCCESS_MODAL, {
      title: "Registration success",
      skipOrgCheck: true
    });
  }, [logout, showModal, authenticatedUser?.email]);

  return (
    <Modal isOpen={true}>
      <ModalBody>
        <RegisterSuccess />
      </ModalBody>
    </Modal>
  );
};

export default RegistrationSuccessModal;
